import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { Step } from './Step';
import { StepArgs } from './types';

type StepperProps<T> = {
  steps: ReadonlyArray<StepArgs<T>>;
  currentStep: StepArgs<T>;
  className?: string;
  stepClassNames?: ComponentProps<typeof Step>['classNames'];
};

export const Stepper = <T,>({ steps, currentStep, className, stepClassNames }: StepperProps<T>) => {
  return (
    <ul className={twMerge('flex grow', className)}>
      {steps.map((step) => (
        <Step<T> key={step.id.toString()} {...step} isSelected={currentStep.id === step.id} classNames={stepClassNames} />
      ))}
    </ul>
  );
};
